<!--智能电箱控制器实时状态卡-->
<template>
  <div id="index"
       class="animate-in">
    <!--顶部搜索筛选-->
    <div class="row">
      <div class="col-md-12">
        <div class="box fz-content-box">
          <div class="box-body fz-box-body">

            <form class="form-inline searchForm"
                  id="searchForm"
                  action="#"
                  method="GET">
              <div class="form-group mr15"><span class="fz-menu-name">运营管理</span></div>

            </form>
          </div>
        </div>
      </div>
    </div>

    <!--数据列表页面-->
    <section class="fz-content pt0"
             ref="capture">
      <div class="fz-content-status">
        <div class="row">
          <div class="col-md-12">
            <div class="box fz-kehu-box">
              <div class="box-body">
                <div class="  pl-pr-0 form-inline">
                  <span class="fz-kehu-info">客户名称：{{deviceData.customer}}</span>
                  <span class="fz-kehu-info">安装位置：{{deviceData.address_sort}}</span>
                  <span class="fz-kehu-info"
                        style="margin-left:50px;">紧急联系电话：{{deviceData.mobile}}</span>
                  <div class="pull-right"
                       style="    font-size: 18px; margin-left:20px">
                    <a href="#"
                       @click="printWindow()"
                       class="dropdown-toggle fz-a-color mr10"
                       title=""
                       data-toggle="dropdown">
                      <i class="fa fa-print"></i>
                    </a>
                    <a href="#"
                       @click="backTop"
                       class="dropdown-toggle fz-a-color mr5"
                       title=""
                       data-toggle="dropdown">
                      <i class="fa fa-remove"></i>
                    </a>
                  </div>
                  <div class="form-group ml30 pull-right"
                       style="margn-right:20px;">
                    <div class="input-group date fz-input-time-width"
                         id="datetimepicker1">
                      <input type="text"
                             class="timeInput form-control input-sm fz-input-radiu" />
                      <span class="input-group-addon fz-group-addon-width">
                        <span class="glyphicon glyphicon-calendar"></span>
                      </span>
                    </div>
                    <span>&nbsp;至&nbsp;</span>
                    <div class="input-group date fz-input-time-width"
                         id="datetimepicker2">
                      <input type="text"
                             class="timeInput form-control input-sm fz-input-radiu" />
                      <span class="input-group-addon fz-group-addon-width">
                        <span class="glyphicon glyphicon-calendar"></span>
                      </span>
                    </div>
                    <div class="form-group">

                      <a href="#"
                         class="fz-goto-search "
                         style=" color:#111619;  padding-left:10px;">
                        <i class="fa fa-download"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row"
             style="padding: 5px 6px;">
          <div class="col-md-12 form-inline">
            <div class="col-md-12 pl-pr-0">
              <div class="fz-machine-box-header col-md-8 form-inline">
                <div class="form-group">
                  <span><strong>{{menuName}} - 实时状态卡</strong></span>
                </div>
                <div class="form-group ml30">
                  <span class="btn btn-circle btn-sm fz-btn-circle-online"></span><span>&nbsp;在线&nbsp;</span>
                  <!-- <span class="btn btn-circle btn-sm fz-btn-circle-offline"></span><span>&nbsp;离线&nbsp;</span>
                                        <span class="btn btn-circle btn-sm fz-btn-circle-close"></span><span>&nbsp;未启&nbsp;用</span> -->
                </div>

                <div class="form-group pull-right">
                  <div class=" "
                       style="padding: 0; margin: 0;">
                    <div>

                      <button @click="toSwitch(1, 'open')"
                              class="btn btn-danger btn-xs app-btn">
                        <i class="fa fa-power-off"></i> 关机 </button>

                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 pl-pr-0">
                <div class="fz-machine-box col-md-4 fz-machine-box"
                     style="padding-left:0">
                  <div class="con">
                    <div class="form-group">
                      <h6 class="mt0"><strong>产品信息</strong></h6>
                      <p>
                        <span class="mr10">
                          设备ID：{{deviceData.product_id}}
                        </span>
                      </p>
                      <p>
                        <span>产品型号：{{deviceData.product.product_model}}</span>
                      </p>
                      <p>IMEI：{{deviceData.imei}}</p>
                      <table class="table fz-order-table-bordered">
                        <tbody>
                          <tr>
                            <td>产品类型： 智能充电</td>
                          </tr>
                          <tr>
                            <td>控制单元数量：{{ deviceData.fires.length}}（可扩展）</td>
                          </tr>
                          <tr>
                            <td>受控类型：{{ deviceData.productName}}</td>
                          </tr>
                          <tr>
                            <td>整柜电气参数： 220VAC50.60Hz 17.6A 3800W</td>
                          </tr>
                          <tr>
                            <td>单元电气参数： 220VAC50.60Hz 1.36A 300W </td>

                          </tr>

                        </tbody>
                      </table>
                      <h6><strong>可接入传感器</strong></h6>
                      <div class="fz-machine-checkbox checkbox">
                        <div class="app-checkbox-item">
                          <span class="check-icon icon_yan_n"></span>
                          <label>烟雾</label>
                        </div>

                        <div class="app-checkbox-item">
                          <span class="check-icon icon_huo_n"></span>
                          <label>气体</label>
                        </div>
                        <div class="app-checkbox-item disabled">
                          <span class="check-icon icon_pm25_n "></span>
                          <label>PM2.5</label>
                        </div>
                        <div class="app-checkbox-item disabled">
                          <span class="check-icon icon_hyan_n "></span>
                          <label>火焰</label>
                        </div>
                        <div class="app-checkbox-item">
                          <span class="check-icon icon_temp_n"></span>
                          <label>温度</label>
                        </div>
                        <div class="app-checkbox-item">
                          <span class="check-icon icon_shi_n"></span>
                          <label>湿度</label>
                        </div>
                        <div class="app-checkbox-item">
                          <span class="check-icon icon_dliu_n"></span>
                          <label>电流</label>
                        </div>
                        <div class="app-checkbox-item">
                          <span class="check-icon icon_dya_n"></span>
                          <label>电压</label>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="fz-machine-box col-md-4 pl-pr-0">

                  <div class=" con ">
                    <div class="mb10"
                         style=" font-size:14px;">
                      <strong>总控设备状态</strong>
                      <div class="pull-right">
                        <!--   <button  @click="toSwitch1Data(1)" 
                                                class="btn btn-success btn-xs app-btn">开机</button> -->

                        <a @click="showSetting"
                           class="btn btn-xs app-btn btn-default"><i style="font-size:12px;"
                             class="iconfont icon-shezhi"></i>设置</a>
                      </div>
                    </div>
                    <div class="fz-bike-left"
                         style="width: 100%;">

                      <div class="fz-xiang-table">
                        <div class="row">
                          <div class="col-sm-8 ">
                            <div class="app-pro">
                              <div class="app-pro-item">
                                <div class="pro-label">电压</div>
                                <div class="pro-txt blue">235 <span>V</span></div>
                              </div>
                              <div class="app-pro-item">
                                <div class="pro-label">设备温度</div>
                                <div class="pro-txt gre">43 <span>℃</span></div>
                              </div>
                              <div class="app-pro-item">
                                <div class="pro-label">工作电流</div>
                                <div class="pro-txt yellow">7.53 <span>A</span></div>
                              </div>

                              <div class="app-pro-item">
                                <div class="pro-label">环境湿度</div>
                                <div class="pro-txt  blue">67 <span>%</span></div>
                              </div>
                              <div class="app-pro-item">
                                <div class="pro-label">总功率</div>
                                <div class="pro-txt purple">1620 <span>W</span></div>
                              </div>
                              <div class="app-pro-item">
                                <div class="pro-label">环境温度</div>
                                <div class="pro-txt gre">28 <span>℃</span></div>
                              </div>
                              <div class="app-pro-item">
                                <div class="pro-label">当月用电量</div>
                                <div class="pro-txt blue">85.2 <span>度</span></div>
                              </div>
                              <div class="app-pro-item">
                                <div class="pro-label">烟雾浓度</div>
                                <div class="pro-txt">0 <span>PPM</span></div>
                              </div>

                              <div class="app-pro-item">
                                <div class="pro-label">总用电量</div>
                                <div class="pro-txt">1752 <span>度</span></div>
                              </div>
                              <div class="app-pro-item">
                                <div class="pro-label">气体浓度</div>
                                <div class="pro-txt ">0 <span>PPM</span></div>
                              </div>

                            </div>
                          </div>
                          <div class="col-sm-4 status-box"
                               style="padding-right:10px; padding-left:0">
                            <div class="app-pro-con">
                              <div class="app-box">
                                <div class="app-icon icon_glv_n"></div>
                                <div class="app-con">
                                  正常
                                </div>
                                <div class="app-label">功率</div>
                              </div>
                              <div class="app-box">
                                <div class="app-icon icon_temp_n"></div>
                                <div class="app-con">
                                  正常
                                </div>
                                <div class="app-label">温度</div>
                              </div>
                              <div class="app-box">
                                <div class="app-icon icon_dya_n"></div>
                                <div class="app-con">
                                  正常
                                </div>
                                <div class="app-label">电压</div>
                              </div>
                              <div class="app-box">
                                <div class="app-icon icon_sshui_n"></div>
                                <div class="app-con">
                                  正常
                                </div>
                                <div class="app-label">涉水</div>
                              </div>
                              <div class="app-box">
                                <div class="app-icon icon_gmen_n"></div>
                                <div class="app-con">
                                  正常
                                </div>
                                <div class="app-label">柜门</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 pl-pr-0">
                  <div class="fz-map">
                    <div id="map"
                         style="width: 100%; height:308px;"></div>
                  </div>
                </div>

              </div>
            </div>

            <div class="fz-machine-bottom col-md-12"
                 style="display: block; height:350px;">
              <div class="fz-machine-bottom-inline ">
                <div class="fz-swiper-main">
                  <div class="mb10"
                       style=" padding-left:10px;  font-size:14px;"><strong>格口实时状态 </strong></div>
                  <div class="fz-swiper-con">
                    <div class="fz-swiper-top-tbn"
                         @click="isShowFire=true">
                      <div class="fz-swiper-btn">
                        <img src="../../static/img/icon.png"
                             width="60"
                             alt=""
                             srcset="">
                      </div>
                      <p>强制启动<br>灭火器</p>
                    </div>

                    <div class="fz-swiper-top-con">
                      <div class="fz-swiper-top-left">
                        <div class="fz-swiper-txt">
                          {{ selectedFire.no }}
                        </div>
                        <div class="fz-swiper-line"></div>
                        <div class="fz-swiper-txt">
                          {{ deviceData.fires.length }}
                        </div>
                      </div>
                      <div class="fz-swiper-top-right">
                        <div class="fz-status-txt green">
                          <span v-if=" selectedFire.pressure/1000 < deviceData.property.x_qi_max && deviceData.property.x_ran > selectedFire.gas">正常</span>
                          <p v-if=" selectedFire.smoke > deviceData.property.x_yan || deviceData.property.x_ran < selectedFire.gas 
                                                                || deviceData.property.x_qi_max < selectedFire.pressure/1000">
                            <span class="red">Ⅰ</span>
                            <span class="red">预警</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="fz-swiper-btm">

                      <div class="fz-status-txt green"> <span v-if=" selectedFire.pressure/1000 < deviceData.property.x_qi_max
                                                            && deviceData.property.x_ran > selectedFire.gas">正常</span>
                        <span v-if=" selectedFire.smoke > deviceData.property.x_yan"
                              class="red">烟雾</span>
                        <span v-if="deviceData.property.x_ran < selectedFire.gas"
                              class="red">燃气</span>
                        <span v-if="deviceData.property.x_qi_max < selectedFire.pressure/1000"
                              class="red">过压</span>
                      </div>
                      <div class="status-p"> <span>T1:</span> {{ selectedFire.t1 }} ℃ T2: {{ selectedFire.t2}} ℃</div>
                      <div class="status-p "
                           :class="selectedFire.pressure/1000  < deviceData.property.x_qi ||  selectedFire.pressure/1000  > deviceData.property.x_qi_max ? 'red':'' "> <span>电压：</span>{{ selectedFire.pressure / 1000 }}V</div>
                      <div class="status-p"> <span>电流:</span> {{ selectedFire.t1 }}A </div>
                      <div class="status-p"> <span>功率:</span> {{ selectedFire.t1 }}W </div>
                      <div class="status-p"> <span>电量:</span> {{ selectedFire.t1 }}WH </div>
                      <div class="status-p"> <span>烟雾浓度:</span> {{ selectedFire.yan }}PPM </div>
                    </div>
                  </div>
                </div>
                <div class="fz-bike-right"
                     style="width: 100%;">

                  <div class="app-item-box"
                       v-for="(item,index) in deviceData.fires"
                       :key="'x'+index"
                       @click="choseFire(item, index)"
                       :class="selectedFire.id == item.id ? 'active':''">
                    <div class="app-itm-title">
                      <span class="span">{{ item.no }}</span>

                      <div class="icon-status">
                        <span v-if="item.status==0"
                              class="green"><span class="dian"></span><span>&nbsp;闲置&nbsp;</span></span>
                        <span v-if="item.status==1"
                              class="yellow"><span class="iconfont icon-chongdianzhong"></span><span>&nbsp;充电中&nbsp;</span></span>
                        <span v-if="item.status==2"
                              class="red1"><span class="iconfont icon-duankai"></span><span>&nbsp;电池断开&nbsp;</span></span>
                        <span v-if="item.status==3"
                              class="green"><span class="iconfont icon-dianchicopy-"></span><span>&nbsp;已充满&nbsp;</span></span>
                        <span v-if="item.status==4"
                              class="yellow"><span class="iconfont icon-naozhong"></span><span>&nbsp;充电时间到&nbsp;</span></span>

                        <span v-if="item.status_online"
                              class="gray"><span class="dian"></span><span>&nbsp;离线&nbsp;</span></span>
                      </div>

                    </div>
                    <div class="app-itm-con">
                      <dir class="ctls">
                        <div>
                          <div v-if="item.has_warning"
                               class="icon-warning"></div>&nbsp;
                        </div>
                        <div class="ctrls">

                          <span class="iconfont icon-zuoyou1 "
                                :class="'tcrtl' + index"></span>
                          <span class="iconfont icon-zuoyou "
                                :class="'tcrtlx' + index"></span>
                        </div>
                      </dir>
                      <swiper :options="{
                                  spaceBetween: 30, centeredSlides: true, autoplay: {
                                    delay: 3500 + index * 100,
                                    disableOnInteraction: false
                                  }, pagination: {
                                    el: '.swiper-pagination',
                                    clickable: true
                                  }, navigation: {
                                    nextEl: '.tcrtlx' + index, prevEl:
                                      '.tcrtl' + index
                                  }
                                }"
                              :auto-play="true"
                              :slides-per-view="3"
                              :space-between="50"
                              style="margin-top:-20px;">
                        <swiper-slide>
                          <div class="itm-con-con">
                            <div class="con-icon icon_temp_n"></div>
                            <div class="co-label">T1</div>
                            <div class="con-icon-txt">
                              <span>{{ item.t1 }}</span> ℃
                            </div>
                          </div>
                        </swiper-slide>

                        <swiper-slide>
                          <div class="itm-con-con">
                            <div class="con-icon icon_temp_n"></div>
                            <div class="co-label">T2</div>
                            <div class="con-icon-txt">
                              <span>{{ item.t2 }}</span> ℃
                            </div>
                          </div>
                        </swiper-slide>

                        <swiper-slide>
                          <div class="itm-con-con">
                            <div class="con-icon icon_dya_n"></div>
                            <div class="co-label">电压</div>
                            <div class="con-icon-txt">
                              <span>{{ item.pressure }}</span> V
                            </div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                          <div class="itm-con-con">
                            <div class="con-icon icon_dliu_n"></div>
                            <div class="co-label">电流</div>
                            <div class="con-icon-txt">
                              <span>{{ item.wet1 }}</span> A
                            </div>
                          </div>
                        </swiper-slide>

                        <swiper-slide>
                          <div class="itm-con-con">
                            <div class="con-icon icon_glv_n"></div>
                            <div class="co-label">功率</div>
                            <div class="con-icon-txt">
                              <span>{{ item.glv }}</span> W
                            </div>
                          </div>
                        </swiper-slide>

                        <swiper-slide>
                          <div class="itm-con-con">
                            <div class="con-icon icon_dliang_n"></div>
                            <div class="co-label">电量</div>
                            <div class="con-icon-txt">
                              <span>{{ item.gas }}</span> WH
                            </div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                          <div class="itm-con-con">
                            <div class="con-icon icon_huo_n"></div>
                            <div class="co-label">烟雾浓度</div>
                            <div class="con-icon-txt">
                              <span>{{ item.smoke }}</span> PPM
                            </div>
                          </div>
                        </swiper-slide>

                      </swiper>
                    </div>
                  </div>

                </div>
              </div>

            </div>

            <!--显示地图-->

          </div>
        </div>
      </div>

    </section>
    <transition name="el-fade-in">
      <v-drag v-if="isShowBatchPro"
              :title="'参数设定'"
              :hiddenCancel="true"
              @cancel="batchProCancel"
              :hiddenConfirm="true"
              :widthData="'550px'">
        <div style="padding:20px"
             class="form">

          <div class="app-can">
            <div class="can-tile">电气设备参数</div>
            <div class="can-con">
              <table class="table">
                <tbody>
                  <tr>
                    <td class="label-title"
                        style="width:80px; text-align:right"></td>
                    <td style="text-align:center">Ⅰ级</td>
                    <td style="text-align:center">Ⅱ级</td>
                    <td style="text-align:center">Ⅲ级</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style="width:80px; text-align:right">电压(过压):</td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_over_dianya_min"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_over_dianya"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_over_dianya_max"></td>
                    <td>V</td>
                  </tr>
                  <tr>
                    <td style="width:80px; text-align:right">电压(欠压):</td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_over_out_dianya_min"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_over_out_dianya"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_over_out_dianya_max"></td>
                    <td>V</td>
                  </tr>
                  <tr>
                    <td style="width:80px; text-align:right">电流:</td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_dianliu_min"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_dianliu"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_dianliu_max"></td>
                    <td>A</td>
                  </tr>
                  <tr>
                    <td style="width:80px; text-align:right">功率:</td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_gonglv_min"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_gonglv"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_gonglv_max"></td>
                    <td>W</td>
                  </tr>
                  <tr>
                    <td style="width:80px; text-align:right">温度:</td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_temp_min"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_temp"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_temp_max"></td>
                    <td>℃</td>
                  </tr>
                  <tr>
                    <td style="width:80px; text-align:right">烟雾:</td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_yan_min"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_yan"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_yan_max"></td>
                    <td>PPM</td>
                  </tr>
                  <tr>
                    <td style="width:80px; text-align:right">气体浓度:</td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_qi_min"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_qi"></td>
                    <td class="txt-tit"><input type="text"
                             v-model="deviceDataProperty.d_qi_max"></td>
                    <td>PPM</td>
                  </tr>

                </tbody>
              </table>
            </div>

          </div>

          <div class="row"
               style="text-align:center">

            <button type="button"
                    id="btnyes"
                    v-on:click="saveDeviceP"
                    class="btn btn-warning">保存</button>
          </div>
        </div>

      </v-drag>
    </transition>

  </div>
</template>

<script>
import pagination from "@/components/pagination.vue"
import ydSwitch from '@/components/switch/src/switch.vue';
import { systemUI } from '@/utils/system';
import '@/static/plugins/bootstrap-datetimepicker/js/bootstrap-datetimepicker.js';
import '@/static/plugins/bootstrap-datetimepicker/js/locales/bootstrap-datetimepicker.zh-CN.js';
import '@/static/plugins/bootstrap-datetimepicker/css/bootstrap-datetimepicker.css';
import BMap from 'BMap'
import { req } from "../../api/axiosFun"
import vDrag from "@/components/dragDiv.vue"
import html2canvas from 'html2canvas'
import { Swiper as SwiperClass, Navigation, Pagination, Mousewheel, Autoplay } from 'swiper/core'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation])

const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass)

import 'swiper/swiper-bundle.css'


export default {
  name: '',
  data () {
    return {
      menuName: "智能交流充电柜",
      loading: false, // 是显示加载
      startTime: "",
      endTime: "",

      deviceParams: {
        deviceId: "382399440505", // 设备ID
        productType: "HF-9302-kkw", // 产品型号
        imei: "2335929303",
        productName: "智能空气机",
        sn: "AB-232222",
        chouyang: 120,
        power: "80%",
        temperature: "-20℃ - +80℃",
        workTemperature: "<90%",
        control: "定时、远程、遥控",
        area: "<65m2",
      },
      deviceData: {
        fires: [],
        product: {},
        property: {}
      },
      deviceDataProperty: {

      },
      selectedFire: {
        no: 0
      },
      chartData: {
        chartData: [],
        chartData1: [],
      },
      editDeviceData: {},
      switch1: true,  // 开关
      isShowBatchPro: false,  // 开关
      switch2: false,  // 复位
      switch3: false,  // 自检
      switch4: false,  // 自检
      switch4Can: true,  // 自检
      switch1Data: 0,  // 自检
      listData: [

      ],
      mapData: {},
      currentList: [],
      // 分页参数
      num: 0,
      limit: 2,
    }
  },
  components: {
    pagination, Swiper, SwiperSlide,
    vDrag,
    ydSwitch
  },
  inject: ['reload'],
  created () {
    // systemUI.showLoadingModal(true,"加载中...");

  },
  mounted () {
    //必须在组件渲染之后调用
    this._dateDefault();
    this.requestData();
    this.createMap();
  },
  methods: {
    showSetting () {
      this.isShowBatchPro = true;
    },
    batchProCancel () {
      this.isShowBatchPro = false;
    },
    async saveDeviceP () {
      let res = await req('POST', '/device/property-charge/' + this.$route.query.id, this.deviceDataProperty);
      if (res.res == 'ok') {
        this.isShowBatchPro = false;
        this.$toast.open({
          message: '修改成功!',
          type: 'success',
          position: 'top'

        });
      } else {
        this.$toast.open({
          message: '修改失败!',
          type: 'error',
          position: 'top'

        });
      }
      this.ping = true;;
    },
    secondsFormat (s) {
      var day = Math.floor(s / (24 * 3600)); // Math.floor()向下取整
      var hour = Math.floor((s - day * 24 * 3600) / 3600);
      var minute = Math.floor((s - day * 24 * 3600 - hour * 3600) / 60);
      var second = s - day * 24 * 3600 - hour * 3600 - minute * 60;
      if (hour) {
        return hour + ":" + minute + ":" + second;
      } else {
        if (second < 10) {
          if (minute < 10) {
            return "0" + minute + ":" + second + "0";
          } else {
            return minute + ":" + second + "0";
          }
        } else {
          return minute + ":" + second;
        }
      }
    },
    _dateDefault () {
      let _this = this;
      $('#datetimepicker1').datetimepicker({
        language: 'zh-CN',
        format: 'yyyy-mm-dd hh:ii',
        weekStart: 1,
        todayBtn: 1,
        autoclose: 1,
        todayHighlight: 1,
        startView: 2,
        minView: 0,
        maxView: 1,
        forceParse: 0,
      }).on("hide", function (ev) {
        var value = $("#startTime").val();
        _this.startTime = value;
      });

      $('#datetimepicker2').datetimepicker({
        language: 'zh-CN',
        format: 'yyyy-mm-dd hh:ii',
        weekStart: 1,
        todayBtn: 1,
        autoclose: 1,
        todayHighlight: 1,
        startView: 2,
        minView: 0,
        maxView: 1,
        forceParse: 0,
      }).on("hide", function (ev) {
        var value = $("#endTime").val();
        _this.endTime = value;
      });
    },
    printWindow () {
      console.log(this);
      html2canvas(this.$refs.capture).then(canvas => {
        //  this.$refs.addImage.append(canvas);  
        let link = document.createElement('a');
        link.href = canvas.toDataURL();
        link.setAttribute('download', this.menuName + '-实时状态卡-' + this.deviceData.sn + '.png');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
      })
      //    this.$print(document.getElementById('fz-content-status')) 
      //      let subOutputRankPrint = document.getElementById('fz-content-status');
      //         console.log(subOutputRankPrint.innerHTML);
      //         let newContent =subOutputRankPrint.innerHTML;
      //         let oldContent = document.body.innerHTML;
      //         document.body.innerHTML = newContent;
      //         window.print();
      //         window.location.reload();
      //         document.body.innerHTML = oldContent;
      //         return false;
    },
    getNew (value) {

    },
    toSearch () {

    },
    toSwitch1Data () {

    },
    toSwitch () {

    },
    choseFire (item) {
      this.selectedFire = item;
    },
    backTop () {
      window.history.back(-1)
    },
    refresh () {
      this.reload();
    },
    createMap () {

      // 创建Map实例
      var map = new BMap.Map("map")
      // 初始化地图,设置中心点坐标和地图级别
      map.centerAndZoom(new BMap.Point(this.mapData.lat, this.mapData.long), 25)
      //添加地图类型控件
      map.addControl(new BMap.MapTypeControl({
        mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP]
      }))

      var pt = new BMap.Point(this.mapData.lat, this.mapData.long);
      var myIcon = new BMap.Icon(require('../../static/images/point.png'), new BMap.Size(52, 32));
      var marker = new BMap.Marker(pt, { icon: myIcon });  // 创建标注
      map.addOverlay(marker);
      // 设置地图显示的城市 此项是必须设置的
      map.setCurrentCity("深圳")
      //开启鼠标滚轮缩放
      map.enableScrollWheelZoom(true)
      /* eslint-enable */
    },
    async requestData () {



      const that = this;
      let res = await req('GET', '/device/' + this.$route.query.id)
      that.deviceData = res.data;
      that.deviceDataProperty = that.deviceData.property_charge;
      that.ableDevice = res.data.ableDevice;
      that.deviceForwads = res.data.forwards;

      if (this.deviceData.gear > 0 && that.switch1 && this.switch1Data == this.deviceData.gear || this.deviceData.gear < 1 && !that.switch1) {
        that.canSyncSwitch = 0;
        clearInterval(that.timer);
      }
      console.log(that.canSyncSwitch);
      if (that.canSyncSwitch === 0) {

        that.switch1 = that.deviceData.gear > 0 ? true : false;
        if (that.deviceData.gear > 0) {

          that.switch1Data = that.deviceData.gear;
        }
        that.canSyncSwitch = 0;
        if (that.timer) {
          clearInterval(that.timer);
        }
      }
      if (that.switch4Can) {
        that.switch4 = that.deviceData.switch4 > 0 ? true : false;
      }
      if (!that.deviceData.property) {
        that.deviceData.property = {}
      }
      this.$parent.isLoading = false;
      // this.switch1Data =  that.deviceData.gear || 3;
      this.selectedFire = this.deviceData.fires[0] || {};

      if (!that.mapData.long) {
        that.mapData = that.deviceData;
        this.createMap();
      }

      setTimeout(function () {
        if (that.ping) {
          that.requestData();
        }

      }, 3000)
    },
    addDevice () {

    },
  },
}
</script>
<style lang="scss" scoped>
.fz-machine-btn-item {
  background-color: #fff;
  padding: 3px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  > span {
    margin-right: 3px;
  }
}
.fz-bike-left {
  width: 30%;
}
.fz-machine-bottom {
  height: 318px;
}
.fz-machine-bottom-inline {
  display: flex;
}
.fz-xiang-items {
  display: flex;
  align-items: center;
}
.fz-xiang-items img {
  width: 25px;
  height: 25px;
}
.fz-xiang-status-item {
  display: flex;
  height: 20px;
}
.fz-xiang-status {
  display: flex;
  align-items: center;
  justify-content: center;
}
.fz-xiang-status-yes {
  display: inline-block;
  width: 13px;
  height: 13px;
  background-color: #6de873;
  border-radius: 50%;
  margin-right: 5px;
}
.fz-xiang-status-no {
  display: inline-block;
  width: 13px;
  height: 13px;
  background-color: #ed1a1a;
  border-radius: 50%;
  margin-right: 5px;
}
.app-btn {
  border-radius: 30px;
  margin-left: 6px;
  padding: 0 6px;
}
.fz-bike-item {
  display: inline-block;
  cursor: pointer;
}
.fz-bike-itemin {
  padding: 10px;

  border-radius: 6px;
  width: 138px;
  margin: 0 10px 20px 10px;
  position: relative;

  cursor: pointer;
  border: 1px solid #e4e4e4;
  background-color: #f6f6f6;
}
.fz-bike-itemin-top {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.fz-bike-itemin-top span.fz-bike-itemin-top-num {
  width: 30px;
  height: 30px;
  font-size: 18px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  background-color: #4caf50;
  text-align: center;
  color: #fff;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  left: 5px;
  top: 5px;
  border-radius: 20px;
}

.green {
  color: #179c05;
}
.red {
  color: #ff6f6f !important;
}
.fz-bike-itemin-bottom {
  div {
    line-height: 18px;
    font-size: 12px;
    color: #666;
    span {
      display: inline-block;
      color: #888;
    }
  }
}
.fz-bike-itemin-btn {
  border-radius: 50% / 50%;
  font-size: 10px;
  width: 28px;
  height: 20px;
  padding: 2px;
  background-color: #0df117;
  color: #fff;
}
.fz-bike-itemin-btn-charge {
  background-color: #ff9800 !important;
}
.fz-bike-itemin-btn-red {
  background-color: #e53935 !important;
}
.fz-bike-right {
  padding: 10px 0px;
  overflow-y: auto;
  height: 310px;
}
.fz-bike-itemin-noopen {
  background-color: #b5b5b5 !important;
  span.fz-bike-itemin-top-num {
    background-color: #b5b5b5 !important;
    color: #fff !important;
  }
  span.fz-bike-itemin-top-time {
    color: #fff;
  }
  .fz-bike-itemin-center {
    color: #fff !important;
    padding-left: 50px;
  }
}

.fz-xiang-table {
  display: flex;
  flex-direction: row;
}
.fz-btn-item-in-con {
  font-size: 10px;
  text-align: right;
  flex: 1;
  padding-right: 10px;
}
.fz-bike-itemin-center {
  text-align: center;
  color: #0cb100;
  font-weight: bold;

  font-size: 16px;
  margin-left: -10px;
  margin-right: -10px;
  padding: 0 5px;
  min-width: 35px;
  line-height: 35px;
  display: block;
  margin-left: 60px;
}
.app-can {
  .can-tile {
    padding: 10px 0;
  }
  .can-con {
    background: #f3f3f3;
    border-radius: 10px;
    padding: 10px;
    font-size: 12px;
    margin-bottom: 10px;

    input {
      display: inline-block;
      width: 40px;
      margin-right: 4px;
    }
    .can-item {
      display: flex;
      flex-direction: row;
      padding: 5px 0;
      .can-label {
        min-width: 85px;
      }
    }
  }
}
.fz-swiper-main {
  width: 220px;
}
.fz-order-table-bordered {
  margin-bottom: 0;
}
.label-title {
  text-align: right;
}
.txt-tit {
  width: 100px;
  input {
    width: 100% !important;
  }
}
.table > tbody > tr > td,
.table > tbody > tr > th,
.table > tfoot > tr > td,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > thead > tr > th {
  padding: 5px 10px;
}
.chrage-time {
  text-align: right;
}
.fz-machine-box .con {
  border: 1px solid #bababa;
  padding: 10px;
}
</style>

